<script setup lang="ts">
import SiteMapRacksTable from '@/components/eos/site-map/SiteMapRacksTable.vue'
</script>

<template>
  <SiteMapRacksTable> </SiteMapRacksTable>
</template>
